import { createFileRoute } from '@tanstack/react-router';
import ListPage from '../../views/dashboard-lists/list';

export const Route = createFileRoute('/dashboard/lists_/$uuid')({
  component: ListPage,
});
